module.exports = __webpack_public_path__ + "img/instagram.ad1fe911.jpg";